export const formatMoneyBase = ({ value, currency }) => new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(value);

const DEFAULT_CURRENCY = 'EUR';
export const formatMoney = (value, currency = DEFAULT_CURRENCY) => formatMoneyBase({
  value: value || 0,
  currency: currency || DEFAULT_CURRENCY,
});
